import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { CalculationCacheService } from '../../../../core/services/impl/calculation-cache.service';
import { CalculationCacheModel } from '../../../../core/models/calculation-cache.model';
import { CalculationCacheVerificationDialogComponent } from '../../../components/dialogs/calculation-cache-veryfication-dialog/calculation-cache-verification-dialog.component';
import { MatDialog } from '@angular/material';
import { ApplicationStateService } from '../../../services/application-state.service';
import { UrlParamsService } from '../../../../core/services/impl/url-params.service';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { AssetsService } from '../../../services/assets.service';
import {isKIOSKPOLIS, isMPay, isNext, isSkycash} from '../../../../core/utils/utils';

@Component({
  selector: 'app-calculations-cache-section',
  templateUrl: './calculations-cache-section.component.html',
  styleUrls: ['./calculations-cache-section.component.scss'],
  providers: [{provide: LOCALE_ID, useValue: 'pl-PL'}]
})
export class CalculationsCacheSectionComponent extends SectionBase implements OnInit {

  public readonly CALCULATIONS_CACHE_SECTION = 'CALCULATIONS_CACHE_SECTION';

  public sectionVisible = false;
  public calculations: Array<CalculationCacheModel>;

  public iconsDirectoryPath: string;
  isNext = isNext();

  get lastCalculation(): CalculationCacheModel {
    return this.calculations && !!this.calculations.length ? this.calculations[this.calculations.length - 1] : null;
  }

  constructor(private calculationCacheService: CalculationCacheService,
              private applicationState: ApplicationStateService,
              private urlParamsService: UrlParamsService,
              private assetsService: AssetsService,
              private dialog: MatDialog) {
    super();

    this.iconsDirectoryPath = this.assetsService.getIconsDirectoryPath();
  }

  ngOnInit() {
    this.initCalculations();
    this.initSectionVisible();
    this.initBean();
    this.initControlsChanges();
  }

  public initBean(): void {
    this.bean = {}
  }

  public openCalculation(calculation: CalculationCacheModel): void {
    this.dialog.open(CalculationCacheVerificationDialogComponent, CalculationCacheVerificationDialogComponent.getConfigBuilder()
      .buildConfiguration({calculation: calculation}))
      .afterClosed()
      .subscribe(() => {
        this.initCalculations();
        this.initSectionVisible();
      });
  }

  public removeCalculations(): void {
    this.calculationCacheService.removeCalculations();
    this.initCalculations();
    this.initSectionVisible();
  }

  public initControlsChanges(): void {
  }

  public createConfig(): void {
  }

  public submitSection() {
    return true;
  }

  public isSectionValid(): boolean {
    return true;
  }

  public get valid(): boolean {
    return true;
  }

  private initSectionVisible(): void {
    const partnerVisible =  !((isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin);
    this.sectionVisible = partnerVisible && this.calculationCacheService.calculationSectionVisible(this.applicationState.sessionId);
  }

  private initCalculations(): void {
    this.calculations = this.calculationCacheService.getAllCalculations();
  }
}
